/** Matches the HTML attribute injected by the server for a solid first paint. */
export const BOOT_SPLASH_ATTR = 'data-boot-splash';

export function clearBootSplashPaint() {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.removeAttribute(BOOT_SPLASH_ATTR);
  root.style.removeProperty('--boot-splash-bg');
  if (!root.getAttribute('style')?.trim()) {
    root.removeAttribute('style');
  }
  const meta = document.querySelector('meta[name="theme-color"]');
  const restore = meta?.getAttribute('data-boot-theme-restore');
  if (meta && restore) {
    meta.setAttribute('content', restore);
    meta.removeAttribute('data-boot-theme-restore');
  }
}
